import { render, staticRenderFns } from "./ResultDetailInvestInLeft.vue?vue&type=template&id=95f99526&scoped=true&"
import script from "./ResultDetailInvestInLeft.vue?vue&type=script&lang=js&"
export * from "./ResultDetailInvestInLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f99526",
  null
  
)

export default component.exports